module.exports = __webpack_public_path__ + "img/217.75097361.png";